.atm_jb_1ylpe5n{min-width:40px;}
.atm_vy_1ylpe5n{width:40px;}
.atm_e2_1ylpe5n{height:40px;}
.atm_jb_8vuzuz{min-width:56px;}
.atm_vy_8vuzuz{width:56px;}
.atm_e2_8vuzuz{height:56px;}
.atm_26_1pec9uq{background:#ffffff;}
.atm_3f_1fz0aif{border:1px solid #CED3DA;}
.atm_5j_1ssbidh{border-radius:50%;}
.atm_7l_c65eb{color:#000000;}
.atm_9s_1txwivl{display:flex;}
.atm_h_1h6ojuz.atm_h_1h6ojuz{align-items:center;}
.atm_fc_1h6ojuz.atm_fc_1h6ojuz{justify-content:center;}
.atm_uc_fxzqnj{transition:background 250ms ease-out;}
.atm_14w14j3_c65eb:focus,.atm_14w14j3_c65eb:hover{color:#000000;}
.atm_154vueb_j1e0tf:focus{background:#CED3DA;}
.atm_1wmykk2_j1e0tf:hover:not([disabled]){background:#CED3DA;}
.atm_16scgop_1x778eo:active{color:white;}
.atm_1kevezh_1aemfod:active{background:#146EF5;}
.atm_1vv33dc_glywfm:active{box-shadow:none;}
.atm_1yfe54e_j1e0tf:disabled{color:#CED3DA;}
.atm_oln6rx_118lp2q:disabled{background:#F4F5F7;}
.atm_174zlj6_73adwj:disabled{cursor:default;}
.atm_70_1xqlxq8{box-shadow:0px 8px 12px 6px rgba(0, 33, 82, 0.15),0px 4px 4px 0px rgba(0, 0, 0, 0.25);}
.atm_mk_stnw88{position:absolute;}
.atm_26_1aemfod{background:#146EF5;}
.atm_7l_1x778eo{color:white;}
.atm_14w14j3_1pec9uq:focus,.atm_14w14j3_1pec9uq:hover{color:#ffffff;}
.atm_154vueb_1aemfod:focus{background:#146EF5;}
.atm_1tgqd35_1n93km5:hover{background:#0045AD;}
.atm_1kevezh_59g6ep:active{background:#002F75;}
